import { createSlice } from '@reduxjs/toolkit'
import { BLUE } from '../../colors'
import { SPHERO } from '../../constants'

export const onLoadPageSettingsReducer = (state, { payload }) => {
  const { navbar, footer, footerFixed } = payload

  const newState = {
    ...state,
    navbar,
    footer,
    footerFixed
  }
  return newState
}

export const updateMainNavbar = (state, { payload }) => {
  const { mainNavbar } = payload

  const newState = {
    ...state,
    mainNavbar
  }
  return newState
}

export const updateFooterReducer = (state, { payload }) => {
  const { footerColor } = payload

  const newState = {
    ...state,
    footerColor
  }
  return newState
}

export const updateFamilyReducer = (state, { payload }) => {
  const family = payload

  return {
    ...state,
    family
  }
}

export const updateNavBarReducer = (state, { payload }) => {
  const navBarActiveItem = payload

  const newState = {
    ...state,
    navBarActiveItem
  }

  return newState
}

const pageSlice = createSlice({
  name: 'page',
  initialState: {
    navbar: true,
    footer: true,
    footerColor: BLUE,
    family: SPHERO,
    footerFixed: false,
    mainNavbar: true,
    navBarActiveItem: ''
  },
  reducers: {
    onLoadPageSettings: onLoadPageSettingsReducer,
    updateFooter: updateFooterReducer,
    updateFamily: updateFamilyReducer,
    updateNavBar: updateNavBarReducer,
    onLoadMainNavbar: updateMainNavbar
  }
})

const { actions, reducer } = pageSlice

export const {
  onLoadPageSettings,
  updateFooter,
  updateFamily,
  updateNavBar,
  onLoadMainNavbar
} = actions

export default reducer
